jQuery(document).ready(function($) {
    $(document).on('click', '.js-view-events', function() {
        $('html, body').animate({
            scrollTop: jQuery('#root-archive-products').offset().top - $('.main-header').outerHeight() - $('.breadcrumb').outerHeight()
        }, 600);
    });
})
